export default "__VITE_ASSET__HGzOoERe__"